export const ADJUDICATION_STATUS: {[key:string] : any } = {
    ASSIGNED : {name: 'Asignado', color:'green'},
    INTERMEDIATION : {name: 'Intermediación', color:'gold'},
    COMPANY : {name: 'Provisión Interna', color:'blue'},
    NON_STOCK : {name: 'Compra Externa', color:'red'}    
  }

  export const SALE_STATUS: {[key:string] : any } = {
    SOLD : {name: 'Vendido', color:'green'},
    INTERMEDIATION : {name: 'Intermediación', color:'gold'},
    COMPANY : {name: 'Venta Interna', color:'blue'}
  }